import request from "@/router/axios";

// 获取应急专家列表（分页）
export const getList = (data) => {
  return request({
    url: "/api/produce/emergency-expert/select/page",
    method: "post",
    data,
  });
};

// 获取应急专家列表（去重分页）
export const getDistinctList = (data) => {
  return request({
    url: "/api/produce/emergency-expert/select/distinct/page",
    method: "post",
    data,
  });
};

// 获取应急专家详情
export const getDetail = (id) => {
  return request({
    url: "/api/produce/emergency-expert/select/id",
    method: "get",
    params: { id },
  });
};

// 新增应急专家
export const add = (data) => {
  return request({
    url: "/api/produce/emergency-expert/insert",
    method: "post",
    data,
  });
};

// 更新应急专家
export const update = (data) => {
  return request({
    url: "/api/produce/emergency-expert/update",
    method: "post",
    data,
  });
};

// 删除应急专家（单个）
export const remove = (id) => {
  return request({
    url: "/api/produce/emergency-expert/delete/id",
    method: "get",
    params: { id },
  });
};

// 批量删除应急专家
export const removeBatch = (ids) => {
  return request({
    url: "/api/produce/emergency-expert/delete/ids",
    method: "get",
    params: { ids },
  });
};

// 下载应急专家导入模板
export const downloadImportTemplate = () => {
  return request({
    url: "/api/produce/emergency-expert/import-template",
    method: "get",
    responseType: "blob",
  });
};

// 导出应急专家 Excel
export const exportExcel = (data) => {
  return request({
    url: "/api/produce/emergency-expert/export/excel",
    method: "post",
    data,
    responseType: "blob",
  });
};

// 导入应急专家 Excel
export const importExcel = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return request({
    url: "/api/produce/emergency-expert/import-excel",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
